export default () => ({
  attendanceQualityInfo: null,
  isLoading: true,
})
